import { Attrs, MinzeElement } from 'minze'

export interface LvcCreateContributionIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcCreateContributionIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 48],
    ['data-height', 48],
  ]
  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.03831 11.3599C1.95774 11.2656 2.01145 11.1174 2.13232 11.0938C4.38507 10.6526 6.65796 10.3293 8.94092 10.1272C9.15915 10.107 9.39416 10.08 9.55531 9.93181C9.64596 9.84761 9.69967 9.73646 9.75339 9.62531C10.9687 7.11268 12.6642 5.01432 13.8829 2.50505C13.8829 2.49832 13.8929 2.49832 13.8929 2.50505C14.044 3.1551 16.6795 8.04228 18.2171 9.99581C20.5639 10.1608 24.4919 10.7536 25.902 11.0938C25.9994 11.1174 26.0329 11.2353 25.9624 11.306C25.0392 12.2457 22.0109 16.3178 20.9869 17.6415C21.0473 20.2282 21.1414 22.7106 21.4301 25.2771C21.4435 25.3916 21.3361 25.4792 21.2286 25.4421C19.9495 24.9874 15.5078 22.9733 13.8929 22.0437C11.6133 22.9093 8.82006 24.435 6.54045 25.4825C6.39945 25.5465 6.24837 25.4253 6.27523 25.2703C6.73853 22.724 7.00376 20.1743 7.08434 17.5842C7.11791 16.4896 3.069 12.5994 2.03831 11.3633V11.3599Z" stroke="#1E007D" stroke-width="1.25" stroke-miterlimit="10"/>
      <path d="M9.00135 20.5C8.97979 19.4507 9.19849 18.5015 10.9727 17.271C11.5241 16.8896 12.4698 16.4894 13.7912 16.5002C14.4904 16.5056 15.5963 16.5678 16.2247 16.8112C17.3212 17.2331 17.6755 17.4684 18.1806 18.1283C18.6858 18.7881 18.9107 19.5399 19 20.2864" stroke="#1E007D" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M13.6502 9.50382C12.3782 9.43018 11.6692 10.4395 11.3815 10.8684C10.293 12.4971 11.7943 14.0436 12.6409 14.3079C15.1432 15.0789 16.0857 13.3635 15.9939 12.0986C15.9189 11.0113 14.9221 9.57747 13.6502 9.50382Z" stroke="#1E007D" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"/>
    </svg>
  `
  css = () => `
    svg {
      width: ${this.dataWidth}px;
      height: ${this.dataHeight}px;
    }
  `
}
